module.exports = __webpack_public_path__ + "static/wenhuachuancheng.b90f42bc.jpg";